var _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 9,
    y2: 0.5,
    stroke: "#0097A9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8.5,
    x2: 13,
    y2: 8.5,
    stroke: "#0097A9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 4.5,
    x2: 13,
    y2: 4.5,
    stroke: "#0097A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIc);
export default __webpack_public_path__ + "static/media/menu-ic.6e4f15369f40b264f1fa1442eadd624d.svg";
export { ForwardRef as ReactComponent };